exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#consolidatedprintDiv .tox.tox-tinymce {\n    display: none !important;\n}\n", ""]);

// exports
